export default __webpack_public_path__ + "static/media/PRIMEROLONUESTRO.b5ab1ac8.png";